import React from 'react';
import ReactDOM from 'react-dom';
import App from "./routes";

const config = require("./company-data.json");

ReactDOM.render(
    <App config={config}/>,
    document.getElementById('_render-application')
);
